module.exports = __webpack_public_path__ + "static/media/sort-asc.175ccbf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sort-asc.svg
// module id = 7
// module chunks = 1